import { EColor } from '../../types';

// Заменить на цвет из кита, когда цвет будет поддерживаться в ките.
const ACCENT_PRIMARY_POSITIVE = '#34ac0a';

export const getTextColor = (labelColor: EColor) => {
  switch (labelColor) {
    case 'blueGoodPrice':
    case 'blueOnlyCian':
    case 'blue':
      return 'primary_100';
    case 'greenForCheckedOwner':
    case 'greenForOwner':
    case 'green':
    case 'greenForSuperAgent':
      return ACCENT_PRIMARY_POSITIVE;
    case 'orange':
      return 'warning_100';
    case 'white':
      return 'black_100';
    case 'purpleDiscountMortgage':
      return 'purple_label_100';
    default:
      return 'black_100';
  }
};
